import dayjs from 'dayjs'
import * as storageUtils from '@g/utils/storageUtils'

// 控制是否仅在夜间时段(23:00~9:00)标记，还是全天都可以标记
// true: 仅在 23:00~9:00 期间点击按钮立即标记
// false: 全天都可以点击按钮立即标记
const NIGHT_TIME_ONLY = true

// 初始化时从 localStorage 加载缓存数据
const initCheckedOrders = () => {
  const cached = storageUtils.get('checkPreApntd_nightChecked')
  return cached || {}
}

const state = {
  // 存储已在夜间点击"申报相符"的订单ID及过期时间
  // { oid: expireTime }
  checkedOrders: initCheckedOrders()
}

const getters = {
  // 检查订单是否已标记且未过期
  isCheckedAndValid: (state) => (oid) => {
    const expireTime = state.checkedOrders[oid]
    if (!expireTime) {
      return false
    }
    // 检查是否已过期
    const now = Date.now()
    if (now >= expireTime) {
      return false
    }
    return true
  },
  // 暴露配置常量，供组件使用
  nightTimeOnly: () => NIGHT_TIME_ONLY
}

const mutations = {
  // 标记订单为已申报
  setChecked (state, { oid, expireTime }) {
    state.checkedOrders = {
      ...state.checkedOrders,
      [oid]: expireTime
    }
    // 持久化到 localStorage
    storageUtils.set('checkPreApntd_nightChecked', state.checkedOrders, 60 * 24)
  },

  // 清理已过期的记录
  removeExpired (state) {
    const now = Date.now()
    const validOrders = {}

    Object.keys(state.checkedOrders).forEach(oid => {
      if (state.checkedOrders[oid] > now) {
        validOrders[oid] = state.checkedOrders[oid]
      }
    })

    state.checkedOrders = validOrders
    // 更新 localStorage
    storageUtils.set('checkPreApntd_nightChecked', state.checkedOrders)
  }
}

const actions = {
  // 标记订单（计算过期时间）
  markAsChecked ({ commit }, oid) {
    const now = dayjs()
    const hour = now.hour()
    let expireTime

    if (NIGHT_TIME_ONLY) {
      // 仅在夜间时段模式：根据当前时间计算到最近的9:00
      // 如果当前时间在23:00~23:59，过期时间设为次日9:00
      if (hour >= 23) {
        expireTime = now.add(1, 'day').hour(9).minute(0).second(0).millisecond(0).valueOf()
      }
      // 如果当前时间在0:00~9:00，过期时间设为当日9:00
      else if (hour < 9) {
        expireTime = now.hour(9).minute(0).second(0).millisecond(0).valueOf()
      }
      // 其他时间不应该调用这个方法，但以防万一设置1小时后过期
      else {
        expireTime = now.add(1, 'hour').valueOf()
      }
    } else {
      // 全天模式：统一设为次日9:00过期
      if (hour >= 9) {
        // 9:00之后，设为次日9:00
        expireTime = now.add(1, 'day').hour(9).minute(0).second(0).millisecond(0).valueOf()
      } else {
        // 9:00之前，设为当日9:00
        expireTime = now.hour(9).minute(0).second(0).millisecond(0).valueOf()
      }
    }

    commit('setChecked', { oid, expireTime })
  },

  // 清理过期记录
  cleanExpired ({ commit }) {
    commit('removeExpired')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
